<template>
<div v-if="isLoading" class="w100">
  <div id="spinnerWrapper" style="z-index: 9999" :style="spinnerStyle">
    <img src="static/spinner2.svg" alt="spinner" class="spinnerSvg">
  </div>
</div>
</template>

<script>
  export default {
    name: 'Spinner',
    props: {
      isLoading: {
        type: Boolean,
        required: false,
        default: false
      },
      right: Boolean,
      spinnerStyle: [String, Object]
    }
  }
</script>

<style>
  #spinnerWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    top:220px;
  }
  .spinnerSvg {
    z-index: 9999;
    width: 100px;
    height: 100px;
    left: 50%;
    top: 52%;
    position: absolute !important;
    transform: translateX(-50%) translateY(-50%);
  }
  #spinnerWrapper .is-loading:after {
    animation: spinAround 400ms infinite linear;
    border: 2px solid black;
    border-radius: 290486px;
    border-right-color: transparent;
    border-top-color: transparent;
    content: "";
    display: block;
    height: 5em;
    width: 5em;
    left: 51%;
    top: 52%;
    position: absolute !important;
  }
  #spinnerWrapper.is-small .is-loading:after {
    height: 2.5em;
    width: 2.5em;
  }
  #spinnerWrapper .is-loading.margin-left:after {
    left: 62.5%;
    top: 62.5%;
  }
  .modal .modal-card .modal-card-body #spinnerWrapper .is-loading:after {
    left: 45%;
    top: 45%;
  }
  @keyframes spinAround {
    0% {
      transform: rotate(0deg);
    } 100% {
      transform: rotate(359deg);
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/utils/SpinnerRound.vue